import { createContext } from 'react';

const GeneralErrorContext = createContext({});

export { GeneralErrorContext };
